<template>
  <div class="zzzd_CIContainer">
    <div class="zzzd_CIWrapper">
      <div class="zzzd_header">
        <span>企业信息</span>
      </div>
      <div class="zzzd_content">
        <div class="zzzd_top">
          <div class="zzzd_title">基础信息</div>
          <div class="itemWrap">
            <div class="item">
              <span class="item_label">公司名称</span>
              <span class="item_desc">{{corporate_name}}</span>
            </div>
            <div class="item">
              <span class="item_label">认证结果</span>
              <span class="item_desc">{{auth_result_name}}</span>
            </div>
            <div class="item">
              <span class="item_label">联系人</span>
              <span class="item_desc">{{publish_name}}</span>
            </div>
            <div class="item">
              <span class="item_label">联系电话</span>
              <span class="item_desc">{{publish_mobile}}</span>
            </div>
          </div>
        </div>
        <!-- <div class="zzzd_bottom">
          <div class="zzzd_title">基础资质</div>
          <el-table :data="baseData" border style="width: 100%">
            <el-table-column prop="picName" label="资质要求" width="210"></el-table-column>
            <el-table-column prop="status" label="办理状态" width="180"></el-table-column>
            <el-table-column prop="upload" label="上传状态"></el-table-column>
            <el-table-column prop="result" label="机器人判断结果"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
              <el-button type="text" size="small" @click="checkUrl(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="line"></div>
          <div class="zzzd_title">品牌资质</div>
          <el-table :data="brandData" border style="width: 100%">
            <el-table-column prop="picName" label="资质要求" width="180"></el-table-column>
            <el-table-column prop="status" label="办理状态" width="180"></el-table-column>
            <el-table-column prop="upload" label="上传状态"></el-table-column>
            <el-table-column prop="result" label="机器人判断结果"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
              <el-button type="text" size="small" @click="checkUrl(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="line"></div>
          <div class="zzzd_title">行业资质</div>
          <el-table :data="industryData" border style="width: 100%">
            <el-table-column prop="picName" label="资质要求" width="180"></el-table-column>
            <el-table-column prop="status" label="办理状态" width="180"></el-table-column>
            <el-table-column prop="upload" label="上传状态"></el-table-column>
            <el-table-column prop="result" label="机器人判断结果"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
              <el-button type="text" size="small" @click="checkUrl(scope.row)">查看</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div> -->
        <!-- <el-dialog  :visible.sync="dialogUrlVisible">
          <img :src="imgUrl" alt="">
        </el-dialog> -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  enterpriseInfo //企业信息
} from "@/api/qualification.js";
import { logout } from "@/api/user";
import { getCookie, removeCookie } from "@/utils/getToken.js";
export default {
  data() {
    return {
      baseData: [],
      brandData: [],
      industryData: [],
      corporate_name:'',//公司名称
      auth_result_name:'',//认证结果
      publish_name:'',//联系人
      publish_mobile:'',//联系电话
      dialogUrlVisible:false,
      imgUrl:''
    };
  },
  methods: {
    goToHome() {
      this.$router.push("/diagnose/ECommerce/settledType");
    },
    checkUrl(row){
      console.log(row)
      this.dialogUrlVisible = true
      this.imgUrl = row.picUrl
    },
    logout() {
      logout(getCookie("userpin")).then((res) => {
        if (res.status == 0) {
          removeCookie("userpin");
          removeCookie("username");
          // this.$message({
          //   message: "已退出登录！",
          //   type: "success",
          // });
          this.$router.push("/diagnose");
        } else {
          this.$message.error("退出登录失败！");
        }
      });
    },
  },
  mounted() {
    enterpriseInfo({}).then((res)=>{
      if(res.status == 0){
        this.corporate_name = res.data.corporate_name
        this.auth_result_name =res.data.auth_result_name
        this.publish_name =res.data.publish_name
        this.publish_mobile =res.data.publish_mobile
        let  qualifications_pic = res.data.qualifications_pic
        let  brand_pic = res.data.brand_pic
        let  industry_pic = res.data.industry_pic
        qualifications_pic && qualifications_pic.forEach(element => {
          if(element.isChoice){
           if(element.picUrl){
              this.baseData.push({picName:element.picName,status:'已办理',upload:'已上传',result:"通过",picUrl:element.picUrl})
           }else{
             this.baseData.push({picName:element.picName,status:'已办理',upload:'未上传',result:"通过",picUrl:element.picUrl})
           }
          }else {
            if(element.picUrl){
              this.baseData.push({picName:element.picName,status:'未办理',upload:'已上传',result:"未通过",picUrl:element.picUrl})
            }else{
              this.baseData.push({picName:element.picName,status:'未办理',upload:'未上传',result:"未通过",picUrl:element.picUrl})
            }
          }
          
        });
       brand_pic && brand_pic.forEach(element => {
          if(element.isChoice){
           if(element.picUrl){
              this.brandData.push({picName:element.picName,status:'已办理',upload:'已上传',result:"通过",picUrl:element.picUrl})
           }else{
             this.brandData.push({picName:element.picName,status:'已办理',upload:'未上传',result:"通过",picUrl:element.picUrl})
           }
          }else {
            if(element.picUrl){
              this.brandData.push({picName:element.picName,status:'未办理',upload:'已上传',result:"未通过",picUrl:element.picUrl})
            }else{
              this.brandData.push({picName:element.picName,status:'未办理',upload:'未上传',result:"未通过",picUrl:element.picUrl})
            }
          }
          
        });
       industry_pic && industry_pic.forEach(element => {
          if(element.isChoice){
           if(element.picUrl){
              this.industryData.push({picName:element.picName,status:'已办理',upload:'已上传',result:"通过",picUrl:element.picUrl})
           }else{
             this.industryData.push({picName:element.picName,status:'已办理',upload:'未上传',result:"通过",picUrl:element.picUrl})
           }
          }else {
            if(element.picUrl){
              this.industryData.push({picName:element.picName,status:'未办理',upload:'已上传',result:"未通过",picUrl:element.picUrl})
            }else{
              this.industryData.push({picName:element.picName,status:'未办理',upload:'未上传',result:"未通过",picUrl:element.picUrl})
            }
          }
          
        });
      }else if(res.status == -99){
        this.$message('登录超时，请重新登录')
        this.logout()
      }
    })
  },
};
</script>

<style lang="scss" >
.zzzd_CIContainer {
  background: #ebecef;
  width: 100%;
  min-height: 100%;
  border-top: 1px solid #ebecef;
  .zzzd_CIWrapper {
    overflow: hidden;
    .zzzd_header {
      width: 100%;
      height: 50px;
      background: #fff;
      font-size: 18px;
      padding-left: 20px;
      line-height: 50px;
      font-weight: 600;
    }
    .zzzd_content {
      padding: 20px;
      .zzzd_top {
        padding: 0 20px;
        background: #fff;
        margin-bottom: 20px;
        .zzzd_title {
          font-size: 16px;
          font-weight: 600;
          line-height: 50px;
        }
        .itemWrap {
          display: flex;
          flex-wrap: wrap;
          .item {
            width: 50%;
            margin-bottom: 20px;
            .item_label {
              color: #999;
              display: inline-block;
              width: 100px;
            }
            .item_desc {
              color: #333;
            }
          }
        }
      }
      .zzzd_bottom {
        padding: 0 20px 20px;
        background: #fff;
        .zzzd_title {
          font-size: 16px;
          font-weight: 600;
          line-height: 50px;
        }
        .el-table{
          margin-bottom: 30px;
        }
        .line{
          width: 100%;
          height: 1px;
          background: #eee;
        }
      }
    }
  }
}
</style>